import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Row, Col, Container } from "react-bootstrap";
import { marginTop, marginBottom } from "../config/layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { apiRequest } from "../services/apiService";

export default function Menu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (!userData) return;
    console.log("admin response: ", userData);
    if (Number(userData.group) !== 1) {
      navigate("/nopermission");
    }
  }, [userData, navigate]);

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("getpossibilities", "GET");
          if (Array.isArray(response)) {
            setOptions(response);
            console.log("response: ", response);
          } else {
            setOptions([]);
          }
        } catch (error) {
          console.log(error.message);
        }
      };
      fetchData();
    }
  }, [userData, inputValue]);

  return (
    <div>
      <VN userData={userData} />
      <Container>
        <h1>ADMIN</h1>
      </Container>
    </div>
  );
}
